import { createFileRoute, redirect } from '@tanstack/react-router';

// Alerts moved under Backend (Phase: configurable alert rules). Redirect the old
// Admin path so bookmarks and the nav badge keep working.
export const Route = createFileRoute('/admin/alerts')({
  beforeLoad: () => {
    throw redirect({ to: '/backend/alerts' });
  },
  // Route-data exemption: a redirect stub. The screen it forwards to owns the reads.
  component: () => null,
});
